var _templateObject = _taggedTemplateLiteralLoose(['\n  margin: 10px;\n'], ['\n  margin: 10px;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding: 10px;\n'], ['\n  padding: 10px;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  padding: 10px 10px 0;\n  background: ', ';\n  display: flex;\n  flex-wrap: wrap;\n\n  div.tab {\n    border: none;\n    background: none;\n    display: inline-flex;\n    vertical-align: middle;\n    padding: 4px 10px;\n    min-height: 30px;\n    align-items: center;\n    cursor: pointer;\n    border-bottom: 2px solid transparent;\n\n    &.active {\n      border-bottom: 2px solid\n        ', ';\n    }\n    .closeTab {\n      width: 20px;\n      background: none;\n      height: 20px;\n      display: inline-block;\n      vertical-align: middle;\n      margin-left: 5px;\n      position: relative;\n      font-size: 0;\n      border-radius: 30px;\n      opacity: .6;\n\n      &:hover {\n        opacity: .6;\n        background: #fff;\n      }\n      &:after,\n      &:before {\n        content: \'\';\n        display: block;\n        width: 12px;\n        height: 3px;\n        position: absolute;\n        left: 4px;\n        top: 8px;\n        background: #333;\n        transform: rotate(45deg);\n      }\n      &:after {\n        transform: rotate(-45deg);\n      }\n    }\n  }\n'], ['\n  padding: 10px 10px 0;\n  background: ', ';\n  display: flex;\n  flex-wrap: wrap;\n\n  div.tab {\n    border: none;\n    background: none;\n    display: inline-flex;\n    vertical-align: middle;\n    padding: 4px 10px;\n    min-height: 30px;\n    align-items: center;\n    cursor: pointer;\n    border-bottom: 2px solid transparent;\n\n    &.active {\n      border-bottom: 2px solid\n        ', ';\n    }\n    .closeTab {\n      width: 20px;\n      background: none;\n      height: 20px;\n      display: inline-block;\n      vertical-align: middle;\n      margin-left: 5px;\n      position: relative;\n      font-size: 0;\n      border-radius: 30px;\n      opacity: .6;\n\n      &:hover {\n        opacity: .6;\n        background: #fff;\n      }\n      &:after,\n      &:before {\n        content: \'\';\n        display: block;\n        width: 12px;\n        height: 3px;\n        position: absolute;\n        left: 4px;\n        top: 8px;\n        background: #333;\n        transform: rotate(45deg);\n      }\n      &:after {\n        transform: rotate(-45deg);\n      }\n    }\n  }\n']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React, { Component } from 'react';
import styled from 'styled-components';

var CloseableTabs = styled.div(_templateObject);
var TabContent = styled.div(_templateObject2);
var TabPanel = styled.div(_templateObject3, function (props) {
  return props.tabPanelColor || '#f2f2f2';
}, function (props) {
  return props.theme.primary ? props.theme.primary : '#00f';
});

var ReactCloseableTabs = function (_Component) {
  _inherits(ReactCloseableTabs, _Component);

  function ReactCloseableTabs() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReactCloseableTabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      data: _this.props.data,
      activeIndex: _this.props.activeIndex || 0,
      identifier: _this.props.identifier || 'id',
      domActived: {}
    }, _this.handleTabClick = function (id, index) {
      var _this$state = _this.state,
          domActived = _this$state.domActived,
          data = _this$state.data,
          identifier = _this$state.identifier;

      _this.props.onBeforeTabClick && _this.props.onBeforeTabClick(id, index, _this.state.activeIndex);
      var currentId = data[index][identifier];
      domActived[currentId] = data[index];
      _this.setState({ activeIndex: index, domActived: domActived }, function () {
        _this.props.onTabClick && _this.props.onTabClick(id, index, _this.state.activeIndex);
      });
    }, _this.closeTab = function (e, id) {
      e.stopPropagation();
      var activeId = _this.state.data[_this.state.activeIndex][_this.state.identifier];
      var newIndex = activeId >= id ? _this.state.activeIndex - 1 : _this.state.activeIndex;
      var canClose = true;
      if (_this.props.onCloseTab) {
        canClose = _this.props.onCloseTab(id, newIndex);
      }
      if (canClose !== false) {
        var _this$state2 = _this.state,
            data = _this$state2.data,
            domActived = _this$state2.domActived,
            identifier = _this$state2.identifier;

        data.filter(function (item) {
          return item.id !== id;
        });
        var nextId = data[newIndex][identifier];
        if (!domActived[nextId]) {
          domActived[nextId] = data[newIndex];
        }
        if (domActived[id]) {
          delete domActived[id];
        }
        _this.setState({ data: data, activeIndex: newIndex, domActived: domActived });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReactCloseableTabs.prototype.componentWillMount = function componentWillMount() {
    var _state = this.state,
        domActived = _state.domActived,
        activeIndex = _state.activeIndex,
        data = _state.data,
        identifier = _state.identifier;

    if (!data[activeIndex]) return;
    var currentId = data[activeIndex][identifier];
    domActived[currentId] = data[activeIndex];
    this.setState({ domActived: domActived });
  };

  ReactCloseableTabs.prototype.componentDidUpdate = function componentDidUpdate() {
    var _state2 = this.state,
        data = _state2.data,
        domActived = _state2.domActived;

    var arr = Object.values(domActived).filter(function (item) {
      return Object.values(data).map(function (item) {
        return item.id;
      }).indexOf(item.id) === -1;
    });
    if (arr.length <= 0) return false;
    delete domActived[arr[0].id];
    this.setState({ domActived: domActived });
  };

  ReactCloseableTabs.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var domActived = this.state.domActived;
    var data = nextProps.data,
        activeIndex = nextProps.activeIndex;

    var currentId = data[activeIndex].id;
    if (nextProps.data) {
      domActived[currentId] = data[activeIndex];
      var newState = { data: data, domActived: domActived };
      if (Number.isInteger(nextProps.activeIndex)) {
        newState.activeIndex = nextProps.activeIndex;
      }
      this.setState(newState);
    }
  };

  ReactCloseableTabs.prototype.render = function render() {
    var _this2 = this;

    var noTabUnmount = this.props.noTabUnmount;
    var _state3 = this.state,
        domActived = _state3.domActived,
        activeIndex = _state3.activeIndex,
        data = _state3.data,
        identifier = _state3.identifier;

    return React.createElement(
      CloseableTabs,
      { className: this.props.mainClassName || '' },
      React.createElement(
        TabPanel,
        {
          tabPanelColor: this.props.tabPanelColor,
          className: this.props.tabPanelClass || ''
        },
        data.map(function (item, i) {
          return React.createElement(
            'div',
            {
              className: 'tab ' + (i === activeIndex ? 'active' : ''),
              onClick: function onClick() {
                return _this2.handleTabClick(item.id, i);
              },
              key: item.id || i
            },
            item.tab,
            item.closeable && React.createElement(
              'a',
              {
                className: 'closeTab',
                title: _this2.props.closeTitle || 'Close tab',
                onClick: function onClick(e) {
                  return _this2.closeTab(e, item.id);
                }
              },
              _this2.props.renderClose ? _this2.props.renderClose() : 'X'
            )
          );
        })
      ),
      React.createElement(
        TabContent,
        { className: this.props.tabContentClass || '' },
        noTabUnmount ? Object.values(domActived).map(function (item, index) {
          return React.createElement(
            'div',
            {
              key: item.id || index,
              style: { display: item.id === data[activeIndex][identifier] ? 'block' : 'none' }
            },
            item.component
          );
        }) : data[activeIndex] ? data[activeIndex].component : null
      )
    );
  };

  return ReactCloseableTabs;
}(Component);

export default ReactCloseableTabs;